import {
    Source,
} from 'one-model-local';

//TODO: Need to write common method in utils
export const sortFunction = (a: Source, b: Source) => {
    const nameA = a?.firstname?.toLowerCase();
    const nameB = b?.firstname?.toLowerCase();
    return nameA > nameB ? 1 : -1;
}

/**
 * 
 * @param response constains the response of getproviderinfo
 */

export const TransformProviderInfo = (response: any, context: any, soucetypelookup: any) => {
    let sourcedata: Source[] = [];
    let providerresult: any = {
        providersourcedata: sourcedata,
        error: undefined
    }
    const { log } = context;
    log.debug("on-epic", "TransformProviderInfo entered", response);
    // TODO:verify backend team check for errors
    if (response && (response.status >= 400 || response.type == "error")) {
        providerresult.error = response;
    }
    if (response && response.length > 0) {
        response.map((ele: any) => {
            let source: Source = {
                id: undefined,
                mrn: undefined,
                dob: undefined,
                gender: undefined,
                contact: undefined,
                address: undefined,
                lastname: undefined,
                firstname: undefined,
                middlename: undefined,
                department: undefined,
                location: undefined,
            };

            source.id = ele.id;
            source.initials = ele?.name?.charAt(0);
            source.firstname = ele.name;
            source.contact = ele.phone;
            source.typename = soucetypelookup
                && soucetypelookup[1]
                && soucetypelookup[1]?.label;
            source.address = ele.address;
            source.department = ele.department;
            source.location = ele.location;
            source.subtypename = "";

            sourcedata.push(source);
        });
    }
    sourcedata.sort(sortFunction);
    log.debug("on-epic", "TransformProviderInfo transformed data", sourcedata);
    providerresult.providersourcedata = sourcedata;
    return providerresult;
}